import React, { useState, useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, AuthContext } from './AuthContext';
import ErrorBoundary from './components/ErrorBoundary';
// Update all imports to use capital 'V' in Views
import HomePage from './Views/HomePage';  // Changed from './views/HomePage'
import AuthedHomePage from './Views/AuthedHomePage';
import GoogleSignUp from './Views/GoogleSignUp';
import PrivateRoute from './components/PrivateRoute';
import SuccessPage from './Views/SuccessPage';
import CanceledPage from './Views/CanceledPage';
import PrivacyPolicy from './Views/PrivacyPolicy';
import Contact from './Views/Contact';
import './App.css';
import './firebase';
import CustomSuccessPage from './components/personalstuff/CustomSuccessPage';
import CustomFailPage from './components/personalstuff/CustomFailPage';
import VideoSuccessPage from './components/personalstuff/VideoSuccessPage';
import AgeVerification from './Views/AgeVerification';

console.log('Current Environment:', process.env.REACT_APP_ENV);

function App() {
    return (
        <ErrorBoundary>
        <AuthProvider>
            <Router>
                <div className="App">
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/google-signup" element={<GoogleSignUp />} />
                        <Route 
                            path="/auth-home" 
                            element={
                                <PrivateRoute>
                                    <AuthedHomePage />
                                </PrivateRoute>
                            } 
                        />
                        <Route path="/success" element={<PrivateRoute><SuccessPage /></PrivateRoute>} />
                        <Route path="/canceled" element={<PrivateRoute><CanceledPage /></PrivateRoute>} />
                        <Route path="/age-verification" element={<PrivateRoute><AgeVerification /></PrivateRoute>} />
                        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/custom-success" element={<CustomSuccessPage />} />
                        <Route path="/custom-fail" element={<CustomFailPage />} />
                        <Route path="/video-success" element={<VideoSuccessPage />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </div>
            </Router>
        </AuthProvider>
        </ErrorBoundary>
    );
}

export default App;